import { useEffect } from "react";
import BreadCrumb from "../../components/BreadCrumb";

const Index = ({
    breadcrumbList,
    pageDetails,
    descriptionRef,
    isLoading
}) => {

    const scopeStyles = (html) => {
        return html.replace(/<style([^>]*)>([\s\S]*?)<\/style>/gi, (match, attr, css) => {
            // Prefix every selector inside the style tag with .full_description_text
            const scopedCss = css.replace(/(^|\})\s*([^{]+)/g, (fullMatch, brace, selector) => {
                if (selector.includes('@')) return fullMatch; // Skip @media, @keyframes
                return `${brace} .full_description_text ${selector}`;
            });
            return `<style${attr}>${scopedCss}</style>`;
        });
    };

    useEffect(() => {
        const container = descriptionRef.current;
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = pageDetails?.content;
        const scriptTags = tempDiv.querySelectorAll('script');
        scriptTags.forEach((oldScript) => {
            const newScript = document.createElement('script');
            for (let attr of oldScript.attributes) {
                newScript.setAttribute(attr.name, attr.value);
            }
            newScript.text = oldScript.textContent;

            container.appendChild(newScript);
        });
    }, [pageDetails?.content]);
    return (
        <>
            <div className="container">
                <BreadCrumb list={breadcrumbList} />
            </div>

            {
                isLoading ?

                    <section className="terms_condition">
                        <div className="terms_condition_part">
                            <div className="container">
                                <div className="terms_condition_box">
                                    <div className="title_box skeleton">
                                        <h3>Terms & Condition</h3>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-8">
                                            <div className="content_box">
                                                <div className="box_box">
                                                    <h6 className="skeleton">In pellentesque nisl ut turpis ornare, ac tempor urna pulvinar</h6>
                                                    <p className="skeleton">In pellentesque nisl ut turpis ornare, ac tempor urna pulvinar. Aliquam porta vel elit quis congue. Curabitur varius arcu quis ex iaculis, eu tincidunt nulla mattis. Morbi commodo iaculis placerat. Maecenas vehicula, urna vel dapibus finibus, urna velit tempus elit, ut tincidunt ex ipsum sit amet quam. Sed aliquam dolor sem, sed porta ipsum placerat luctus. Quisque pretium nisl non ligula gravida, sed pellentesque neque tincidunt. Nam consectetur sem tellus, convallis malesuada lorem iaculis eget. Sed ultrices est vehicula sapien auctor, in placerat elit sagittis. Nullam in arcu in nibh vulputate auctor. Phasellus et nisl lectus. Nam pretium, urna ac efficitur venenatis, metus nisl vestibulum enim, eu dapibus tortor odio sed dolor. Morbi tempor venenatis convallis.</p>
                                                    <p className="skeleton">Ut id urna viverra diam sollicitudin eleifend vel et turpis. Vestibulum vehicula, diam eu sodales dignissim, justo odio suscipit nisl, sit amet iaculis enim nibh vel lorem. In hac habitasse platea dictumst. Nunc sollicitudin tempus ligula sed maximus. Mauris ac vulputate lectus. Duis tincidunt id magna eu posuere. Donec commodo arcu sit amet lectus fringilla molestie. Morbi vestibulum sapien et augue dictum hendrerit ut quis lacus. Nulla aliquam turpis eu quam ornare eleifend. Nullam id elementum tortor.</p>
                                                </div>
                                                <div className="box_box">
                                                    <h6 className="skeleton">Donec et scelerisque nisi. Maecenas nibh diam, luctus ac</h6>
                                                    <p className="skeleton">Aliquam erat volutpat. Cras quis efficitur neque, nec cursus velit. Duis sit amet ligula tempus, tempus nibh eget, ullamcorper erat. Aliquam erat volutpat. Aliquam justo elit, imperdiet tristique vestibulum eget, vestibulum sit amet metus. Morbi sit amet convallis lorem. Sed quis sem dolor.</p>
                                                    <p className="skeleton">Donec lorem lacus, condimentum vitae vulputate vitae, egestas vitae nulla. Nullam consectetur risus vel eleifend faucibus. Mauris auctor, enim non facilisis dapibus, nibh ante varius diam, eu commodo dolor ante non nibh. Mauris vulputate diam eget ullamcorper cursus. Mauris urna elit, iaculis non nunc quis, pulvinar dignissim sem. Mauris quis blandit enim, a mattis tortor. Nam dictum condimentum sem, nec varius risus pellentesque vel. Donec a mauris quam. Phasellus lobortis metus magna, at convallis justo rhoncus vitae. Curabitur a nunc nibh. Aliquam et lacus sed turpis convallis tristique. Nulla lacinia finibus nunc tempus fringilla. Mauris ut mi non mi consequat feugiat at et justo. Aenean luctus hendrerit consectetur. Praesent pharetra accumsan erat sit amet eleifend.</p>
                                                    <p className="skeleton">Aliquam erat volutpat. Cras quis efficitur neque, nec cursus velit. Duis sit amet ligula tempus, tempus nibh eget, ullamcorper erat. Aliquam erat volutpat. Aliquam justo elit, imperdiet tristique vestibulum eget, vestibulum sit amet metus. Morbi sit amet convallis lorem. Sed quis sem dolor.</p>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    :
                    <div
                        id='full_description_text_activity'
                        className="comon-tags-class"
                        ref={descriptionRef}
                        dangerouslySetInnerHTML={{ __html: pageDetails?.content ? scopeStyles(pageDetails?.content).replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '') : "" }}

                    />
            }

        </>
    )

}
export default Index;